import { render, staticRenderFns } from "./ToccaVinoAddEvent.vue?vue&type=template&id=6ed446cc&"
import script from "./ToccaVinoAddEvent.vue?vue&type=script&lang=js&"
export * from "./ToccaVinoAddEvent.vue?vue&type=script&lang=js&"
import style0 from "./ToccaVinoAddEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports